module.exports = __webpack_public_path__ + "img/img_tuto_get_link.1b02e18d.png";